export function sysMessage(message) {
  let { userName = '', roleName = '', applicationName = '', operateType } = JSON.parse(message);
  if (operateType === 'IN') {
    return `${userName} 将你添加为 ${roleName}，所属应用 ${applicationName}`;
  } else {
    return `${userName} 将你移出了 ${roleName}，所属应用 ${applicationName}`;
  }
}
